<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";

export default {
  page: {
    title: "Pay Petty Cash",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Pay Petty Cash",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "payments",
          href: "/pettycash/payments",
        },
        {
          text: "Pay Petty Cash",
          active: true,
        },
      ],
      data: {
        account: "",
        paidAmount: "",
        id: this.$route.params.id,
      },
      pageError: {
        accountError: false,
      },
    };
  },

  computed: {
    ...mapGetters("accounts", ["getExpenseAccounts"]),
    ...mapGetters("pettycash", ["getPettyCash", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    getPettyCash(newVal) {
      this.data.paidAmount = this.calculateSum(newVal.petty_items);
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchExpenseAccounts: "accounts/fetchExpenseAccounts",
      FetchPettyCash: "pettycash/fetchPettyCash",
      PettyCashPay: "pettycash/pettyCashPay",
    }),

    payPetty() {
      this.validateInputs() ? this.PettyCashPay(this.data) : null;
    },

    validateInputs() {
      if (this.data.account == "") {
        this.pageError.accountError = true;
        return false;
      } else {
        this.pageError.accountError = false;
        return true;
      }
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    calculateSum(items) {
      return items.reduce((accumulator, object) => {
        return accumulator + object.quantity * object.amount;
      }, 0);
    },
  },
  created() {
    this.FetchExpenseAccounts();
    this.FetchPettyCash({ id: this.$route.params.id });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row d-flex"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_total_students')
        )
      "
    >
      <div class="col-md-11 mx-auto">
        <div class="card row">
          <div class="card-body col-md-12 mx-auto row">
            <div class="col-md-8">
              <b-card class="mb-2" no-body>
                <b-row no-gutters class="align-items-center">
                  <b-col md="12">
                    <b-card-header>
                      <!-- <strong class="card-title mb-2 text-uppercase d-flex"> -->
                      <router-link
                        to="/pettycash/payments"
                        class="text-secondary float-begining"
                        style="margin-right: 20px"
                      >
                        <span style="font-size: 20px">
                          <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        </span>
                      </router-link>
                      <strong class="text-primary float-end">
                        Requested By: {{ getPettyCash.user.name }}
                      </strong>
                    </b-card-header>
                    <b-card-body>
                      <b-card-text>
                        <table class="table mt-2">
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Quantity</th>
                              <th scope="col">Total</th>
                              <th scope="col">Narration</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(pettyItem,
                              petttyIndex) in getPettyCash.petty_items"
                              :key="petttyIndex"
                            >
                              <td>{{ pettyItem.name }}</td>
                              <td>{{ pettyItem.amount }}</td>
                              <td>{{ pettyItem.quantity }}</td>
                              <td>
                                {{
                                  thousandSeperater(
                                    pettyItem.amount * pettyItem.quantity
                                  )
                                }}
                              </td>
                              <td>
                                <p>{{ pettyItem.narration }}</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <strong class="text-muted float-end">
                          Amount:
                          <b>
                            {{
                              thousandSeperater(
                                calculateSum(getPettyCash.petty_items)
                              )
                            }}</b
                          >
                          | Date:
                          <b>{{ getPettyCash.request_date }}</b></strong
                        >
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </div>
            <div class="col-md-4">
              <form @submit.prevent="payPetty()">
                <div class="row d-flex">
                  <div class="form-group col-md-12 mb-3">
                    <!-- <label>Paid Amount</label> -->
                    <input
                      type="hidden"
                      class="form-control"
                      v-model="data.paidAmount"
                      required
                    />
                  </div>
                  <div class="form-group mb-3 col-md-12">
                    <label>Allocate Expense to Account</label>
                    <model-list-select
                      required
                      :list="getExpenseAccounts ? getExpenseAccounts : []"
                      v-model="data.account"
                      option-value="id"
                      option-text="acc_name"
                      class="mb-2"
                      placeholder="Select Account"
                      @input="validateInputs()"
                    >
                    </model-list-select>
                    <span v-if="pageError.accountError" class="text-danger"
                      >This Field is Required</span
                    >
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    v-if="SaveStatus"
                    disabled
                    type="button"
                    class="btn btn-sm btn-outline-success"
                  >
                    <b-spinner
                      variant="success"
                      small
                      label="Spinning"
                    ></b-spinner>
                    Paying...
                  </button>
                  <button
                    v-else
                    type="submit"
                    class="btn btn-sm btn-outline-success"
                  >
                    <i class="fa fa-check"></i>
                    Make Payment
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
